import { CompleteProfileModal } from "../behaviors/CompleteProfileModal";
import { ComponentFactory } from "../service/ComponentFactory";
import { DomUtil } from "../util/DomUtil";
import { EventUtil } from "../util/EventUtil";
import { WyanokeUtil } from "../util/WyanokeUtil";
import { moduletracking } from "../Wyanoke/ModuleTracking";
import { Component } from "./base/Component";
import { HealioHeader } from "./healioGlobal/HealioHeader";

export class BackNextButton extends Component {
  public static readonly NextNavigationEvent: string = "NextNavigationEvent";
  public static readonly BackNavigationEvent: string = "BackNavigationEvent";
  public static readonly AboutToContinueEvent: string = "AboutToContinueEvent";
  public static readonly UpdateStepsEvent: string = "UpdateStepsEvent";
  public static readonly NextNavigationCanContinueEvent: string = "NextNavigationCanContinue";

  private readonly _next: HTMLButtonElement;
  private readonly _back: HTMLButtonElement;
  private readonly _nextError: HTMLElement | null;

  private _showUserReviewedModal: boolean;
  private _userDirection: HTMLButtonElement;
  private _reviewModalOptionYes!: HTMLInputElement;
  private _reviewModalOptionNo!: HTMLInputElement;
  private _isOpen: boolean;
  private _hasMasterClassModal: boolean;
  private _registrationAdjustmentsEnabled: boolean;
  private _shouldShowErrorMessage: boolean;

  private UserReviewedModal = (document.getElementById("userReviewedModal") ||
    null) as HTMLElement;

  constructor(element: HTMLElement) {
    super(element);

    // Check if registration adjustments are enabled
    this._registrationAdjustmentsEnabled = this.isRegistrationAdjustmentsEnabled();

    // set default as next
    this._userDirection = DomUtil.query(element, "button[data-action='next']");
    this._isOpen = false;
    // handle next button
    this._next = DomUtil.query(element, "button[data-action='next']");
    this._next.addEventListener("click", (ev) => this.handleNext(ev));
    window.addEventListener("activity.backnextbutton.next", (ev) =>
      this.handleNext(ev)
    );
    window.addEventListener(BackNextButton.NextNavigationCanContinueEvent, () =>
      this.hideNextError()
    );

    this._hasMasterClassModal = this._next.dataset.masterclass == "true";

    // handle back button
    this._back = DomUtil.query(element, "button[data-action='back']", false);
    if (this._back) {
      this._back.addEventListener("click", (ev) => this.handleBack(ev));
    }

    this._nextError = element.querySelector("[data-backnext-error]");

    // set up the "did you review the step content" modal if needed.
    this._showUserReviewedModal =
      element.getAttribute("data-user-reviewed-modal") === "1";
      if (
        this._showUserReviewedModal &&
        this.UserReviewedModal !== null &&
        this.UserReviewedModal !== undefined
      ) {
        this.setModalVars(element);

        $(this.UserReviewedModal).on("show.bs.modal", () => {
          this._isOpen = true;
        });

        $(this.UserReviewedModal).on("hidden.bs.modal", () => {
          this._isOpen = false;
        });
      }

      this._shouldShowErrorMessage = element.getAttribute("data-show-error-message") === "1";

  }

  /**
   * Checks if registration adjustments are enabled via the divRegCheck element
   */
  private isRegistrationAdjustmentsEnabled(): boolean {
    const regCheckElement = document.getElementById("divRegCheck");
    if (regCheckElement) {
      const enabled = regCheckElement.getAttribute("data-enabled");
      return enabled === "1";
    }
    return false;
  }

  public next(): void {
    const click = EventUtil.createCustomEvent("click", null);
    this._next.dispatchEvent(click);
  }

  public disableNext(): void {
    this._next.classList.add("disabled");
    this._next.setAttribute("disabled", "disabled");
    this._next.removeEventListener("click", (ev) => this.handleNext(ev));
    window.removeEventListener("activity.backnextbutton.next", (ev) =>
      this.handleNext(ev)
    );
  }

  /** Re-enable Next after programmatic disable (e.g. Copient embed gate). */
  public enableNext(): void {
    this._next.classList.remove("disabled");
    this._next.removeAttribute("disabled");
  }

  private hideNextError(): void {
    if (this._nextError) {
      this._nextError.classList.add("d-none");
    }
  }

  private showNextError(): void {
    if (this._nextError && this._shouldShowErrorMessage) {
      this._nextError.classList.remove("d-none");
    }
  }

  private async handleNext(ev: Event): Promise<void> {
    this.hideNextError();
    this._userDirection = this._next;
    const profile = await WyanokeUtil.loadUserProfile(true, false);

    if (!profile || profile.isLoggedIn?.toLowerCase() === "false") {
      this._element.dispatchEvent(
        EventUtil.createCustomEvent(
          HealioHeader.UnauthenticatedActionEvent,
          null
        )
      );

      return;
    }

    // Check if profile is complete when registration adjustments are enabled
    console.log("[Next Button] - Checking if registration adjustments are enabled");
    if (this._registrationAdjustmentsEnabled) {
      console.log("[Next Button] - Registration adjustments are enabled");
      if (profile.completeuser === "False") {
        console.log("[Next Button] - User profile is incomplete, loading reminder modal");
        CompleteProfileModal.loadReminderModalForBackNext(
          profile.email || "",
          profile.contactid || ""
        );
        return;
      }
    }

    ev.stopPropagation();

    console.log("[Next Button] - About to fire navigation event");

    const promise = await EventUtil.dispatchAsyncEvent(
      this._element,
      BackNextButton.NextNavigationEvent
    );

    console.log("[Next Button] - Event fired");

    console.log(promise);

    if (this.openReviewModal()) {
      return;
    }

    if (promise) {
      ev.preventDefault();
      const shouldContinue = promise;

      console.log(shouldContinue);
      if (shouldContinue) {

        if(this.openMasterClassModal()) {
          return;
        }

        const aboutToContinuePromise = EventUtil.dispatchAsyncEvent(
          this._element,
          BackNextButton.AboutToContinueEvent
        );

        await aboutToContinuePromise;

        console.log(shouldContinue);
        const href = this._next.dataset.href;
        if (href) {
          console.log("[Next Button] - found href");
          if (this._next.dataset.target === "_blank") {
            window.open(href, "_blank");
            console.log("[Next Button] - targetting _blank");
          } else {
            window.location.href = href;
            console.log("[Next Button] - navigating");
          }
          return;
        }
      } else {
        this.showNextError();
        return;
      }
    } else {
      this.showNextError();
    }

    console.log("[Next Button] - handleNext complete");
  }

  private async handleBack(ev: Event): Promise<void> {
    this._userDirection = this._back;
    console.log("[Back Button] - Clicked");
    ev.stopPropagation();
    ev.preventDefault();

    // console.log("Show modal: " + this._showUserReviewedModal);

    if (this.openReviewModal()) {
      return;
    }

    const promise = await EventUtil.dispatchAsyncEvent(
      this._element,
      BackNextButton.BackNavigationEvent
    );
    if (promise) {
      const href = this._back.dataset.href;
      if (href) {
        console.log("[Back Button] - found href");
        window.location.href = href;
        console.log("[Back Button] - navigating");
      }
      console.log("[Back Button] - handleBack complete");
    }
  }

  private openReviewModal(): boolean {

    if (this._showUserReviewedModal) {
      $("#userReviewedModal").modal();
      this._isOpen = true;
      // this._showUserReviewedModal = false;
      return true;
    } else {
      return false;
    }
  }

  private openMasterClassModal(): boolean {
    if(this._hasMasterClassModal) {
      this._element.dispatchEvent(
        EventUtil.createCustomEvent(
          "gamification.showmodal",
          null
        )
      );
      return true;
    } else {
      return false;
    }
  }

  private setModalVars(element: HTMLElement): void {
    // close buttons
    let closeLinks = DomUtil.queryAll(
      this.UserReviewedModal,
      ".click-and-close"
    );
    closeLinks.forEach((closeLink) =>
      closeLink.addEventListener("click", (closeLink) =>
        this.closeReviewModal(closeLink)
      )
    );

    this._reviewModalOptionYes = DomUtil.query(
      this.UserReviewedModal,
      "input[value='optionYes']"
    );
    $(this._reviewModalOptionYes).on("click", (ev) =>
      this.handleReviewModalInput(ev)
    );

    this._reviewModalOptionNo = DomUtil.query(
      this.UserReviewedModal,
      "input[value='optionNo']"
    );
    $(this._reviewModalOptionNo).on("click", (ev) =>
      this.handleReviewModalInput(ev)
    );

    // click outside of the modal
    document.addEventListener("click", this.clickOutsideReviewModal);


  }

  private handleReviewModalInput(
    ev: JQuery.ClickEvent<
      HTMLInputElement,
      undefined,
      HTMLInputElement,
      HTMLInputElement
    >
  ): any {
    ev.target.setAttribute("checked", "true");

    if (ev.target.value === "optionNo") {
      moduletracking.UseGoogleTrack(
        "VME Completion Modal",
        "Selects they did not complete content_Click_VME Completion Modal",
        "Selects they did not complete content_VME Completion Modal"
      );

      window.setTimeout(() => {
        $("#userReviewedModal").modal("hide");
        ev.target.removeAttribute("checked");
      }, 1000);
    } else {
      moduletracking.UseGoogleTrack(
        "VME Completion Modal",
        "Selects they completed content_Click_VME Completion Modal",
        "Selects they completed content_VME Completion Modal"
      );

      window.setTimeout(() => {
        $("#userReviewedModal").modal("hide");
        ev.target.removeAttribute("checked");
        this._showUserReviewedModal = false;
        this._userDirection.click();
      }, 1000);
    }
  }

  public clickOutsideReviewModal(ev: Event) {
    if (this._isOpen) {
      const path = ev.composedPath();
      if (!path.some(el => (el as HTMLElement).id === 'userReviewedModal')) {
        // Close the modal
        alert("Click outside modal detected!");
      }
    }




    // if (
    //   this.UserReviewedModal &&
    //   !this.UserReviewedModal.contains(ev.target as Node)
    // ) {
    //   moduletracking.UseGoogleTrack(
    //     "VME Completion Modal",
    //     "Does not interact with modal_Click_VME Completion Modal",
    //     "Does not interact with modal_VME Completion Modal"
    //   );
    //   //$("#userReviewedModal").modal("hide");
    // }
    // if (this._isOpen) {

    //     moduletracking.UseGoogleTrack(
    //       "VME Completion Modal",
    //       "Does not interact with modal_Click_VME Completion Modal",
    //       "Does not interact with modal_VME Completion Modal"
    //     );
    //     $("#userReviewedModal").modal("hide");
    //     this._isOpen = false;
    //     this._userDirection.click();

    // }
  }

  private closeReviewModal(ev: Event): void {
    let closeMethodTypeElem = ev.currentTarget as HTMLElement;
    if (closeMethodTypeElem) {
      let methodType = closeMethodTypeElem.getAttribute("data-close-method");
      if (methodType) {
        switch (methodType) {
          case "x":
            moduletracking.UseGoogleTrack(
              "VME Completion Modal",
              "Closes modal_Click_VME Completion Modal",
              "Closes modal_VME Completion Modal"
            );
            window.setTimeout(() => {
              $("#userReviewedModal").modal("hide");
              this._showUserReviewedModal = false;
              //this._isOpen = false;
              this._userDirection.click();
            }, 1000);

            break;
          case "skip":
            moduletracking.UseGoogleTrack(
              "VME Completion Modal",
              "Skips modal_Click_VME Completion Modal",
              "Skips modal_VME Completion Modal"
            );
            window.setTimeout(() => {
              $("#userReviewedModal").modal("hide");
              this._showUserReviewedModal = false;
              //this._isOpen = false;
              this._userDirection.click();
            }, 1000);
            break;
          default:
            break;
        }
      }
    }
  }
}

ComponentFactory.registerComponent("BackNextButton", BackNextButton);
